import { Formation } from "../types"

export const posfor33: Formation = {
  id: "posfor33",
  name: "3 - 3",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 4.07861632571568,
          y: 5.352245134834463
        },
        {
          x: 7.3966404084236395,
          y: 7.047455636119045
        },
        {
          x: 10.854748232532716,
          y: 5.595888436339092
        },
        {
          x: 7.972661755560689,
          y: 3.856688195231995
        },
        {
          x: 12.647026800340223,
          y: 3.0812509917301374
        },
        {
          x: 1.280444474488034,
          y: 2.8858535019157894
        }
      ],
      opponents: [
        {
          x: 5.506869809459472,
          y: 4.626326876586768
        },
        {
          x: 9.037065877424489,
          y: 4.916303190279178
        },
        {
          x: 11.13629236073192,
          y: 2.54919273166816
        },
        {
          x: 7.198523098707484,
          y: 3.1769002643252504
        },
        {
          x: 3.0256195797572714,
          y: 2.9068896477082866
        }
      ],
      ball: {
        x: 8.2590414979267,
        y: 6.765839297569212
      },
      goalkeepers: [
        {
          x: 7.079437073556041,
          y: 1.087305340145936
        }
      ]
    }
  ]
}
